import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type UserCourseStatusChipKollegeUserFragment = { __typename?: 'KollegeUser', standardCourse?: { __typename?: 'KollegeUserCourse_StandardV20250418', status: Types.KollegeUserCourseStatus } | null };

export const UserCourseStatusChipKollegeUserFragmentDoc = gql`
    fragment UserCourseStatusChipKollegeUser on KollegeUser {
  standardCourse {
    status
  }
}
    `;